import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccountManagementHttpService } from '../../services/account-management-http.service';

@Component({
  selector: 'app-account-info',
  template: '<router-outlet></router-outlet>',
})
export class AccountInfoComponent implements OnInit, OnDestroy {
  constructor(
    private accountManagementHttpService: AccountManagementHttpService,
  ) {}

  public ngOnInit(): void {
    this.accountManagementHttpService.fetch();
  }

  public ngOnDestroy(): void {
    this.accountManagementHttpService.clear();
  }
}
